export default __webpack_public_path__ + "static/emilyfarley-64e9badb5a0f7bc85d6d673068dcc405.jpg";